import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ec75fc82: FaireBrandEntity = {
  token: "b_ec75fc82",
  type: "brand",
  name: "Toss Designs",
  avatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/40df23cb317b285fba6ca8e1e1a564773730f94219f71ead97f5bbe91717ac12/1557943749.jpg",
  bannerUrl:
    "https://cdn.faire.com/fastly/adb8d9b424548f3ea258d24ad0d92fe288661e364bf9f16886d61d18b6ed53cb.png",
  logoUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/40df23cb317b285fba6ca8e1e1a564773730f94219f71ead97f5bbe91717ac12/1557943749.jpg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/adb8d9b424548f3ea258d24ad0d92fe288661e364bf9f16886d61d18b6ed53cb.png",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 149,
  rating: 4.9,
  reviewCount: 656,
  isTopShop: true,
  isInsider: true,
  description:
    "Since 2000, Toss Designs has set the standard for thoughtfully crafted women's accessories and gifts. Over more than two decades, the brand has earned the trust of discerning retailers—now carried in over 10,000 better stores nationwide. This growth reflects more than success; it reflects a steadfast commitment to excellence. The Toss Designs team brings care and intention to every piece, curating a collection that balances timeless elegance with modern appeal. For retailers and customers alike, Toss Designs represents quality you can see, craftsmanship you can feel, and a legacy built on getting the details right.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:05.136Z",
    importedBy: "entity-db-cli",
  },
};
